import {Injectable} from "@angular/core";
import {Http} from "@angular/http";
import {UrlService} from "../url.service";
import {AuthentService} from "../authent.service";
import {FamiliesService} from "../families.service";
import {ContactForm} from "../../components/index/contact-form";

@Injectable()
export class PublicService extends FamiliesService {

    constructor(private http:Http, private urlService:UrlService, private authent:AuthentService) {
        super();
    }

    sendContact(contactRequest:ContactForm) {
        return this.http.post(this.urlService.getSendContactUrl(), contactRequest, this.authent.getJSONHeaders())
            .catch(this.handleError);
    }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/services/data/public.service.ts